'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { getFullUrl } from 'hubspot-url-utils';
import * as Hublets from 'hubspot-url-utils/hublets';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
import MediaQuery from 'ecosystem-marketplace-core/components/layout/MediaQuery';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics';
import ThemeDetailsUsageTrackerContext from '../../context/ThemeDetailsUsageTrackerContext';

const ThemeShareButton = (_ref) => {
  let {
    responsive,
    section
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["responsive", "section"]);

  const {
    slug
  } = useParams();
  const {
    trackInteraction
  } = useContext(ThemeDetailsUsageTrackerContext);
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.MD]: false
    }
  });
  const computedShareUrl = useMemo(() => {
    return `${getFullUrl('app', {
      hubletOverride: Hublets.na1
    })}/l/ecosystem/marketplace/assets/themes/${slug}`;
  }, [slug]);
  return /*#__PURE__*/_jsxs(UICopyButton, Object.assign({}, rest, {
    onClick: () => trackInteraction('click share link', {
      section
    }),
    "data-hs-analytics-id": getThemeEventSelectorId('SHARE'),
    value: computedShareUrl,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "share",
      size: responsive && isMobileView ? 'xs' : null
    }), /*#__PURE__*/_jsx(MediaQuery, {
      minScreenSize: responsive ? ScreenSizes.MD : ScreenSizes.XS,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.share"
      })
    })]
  }));
};

ThemeShareButton.propTypes = {
  responsive: PropTypes.bool,
  section: PropTypes.string
};
export default ThemeShareButton;